import React, { useEffect } from "react";
import PropTypes from "prop-types";

import getCookie from "ati-utils/getCookie";

const getUrl = () => {
  try {
    return new URL(window?.location?.href);
  } catch {
    return {};
  }
};

const LoginPopup = ({
  baseUrl,
  onLoginClose,
  onUserLogin,
  onRestorePasswordRedirect,
  onUserRegister,
  next,
  fastreg,
  ignoreIframe,
  additionalQueryParams,
}) => {
  const url = getUrl();
  const showIntegratorsKey = "showIntegrators";
  const showIntegrators = url?.searchParams?.get(showIntegratorsKey) === "true";

  const receiveMessage = (event) => {
    let message = null;

    try {
      message = JSON.parse(event.data);
    } catch (err) {
      message = event.data;
    }

    if (message === "user.logged.out") {
      onLoginClose();
    } else if (message === "user.logged.in") {
      onUserLogin();
      onLoginClose();
    } else if (message === "redirect.register") {
      onUserRegister();
      onLoginClose();
    } else if (message === "redirect.send.password") {
      onRestorePasswordRedirect();
      onLoginClose();
    }
  };

  useEffect(() => {
    window.addEventListener("message", receiveMessage, false);

    let atiapp = getCookie("atiapp");

    if (!atiapp) {
      atiapp = url.searchParams.get("atiapp");
    }

    const redirectUrl = `https://id.${baseUrl}/login/`;

    if (atiapp === "1") {
      window.location.href = redirectUrl;
    }

    return () => window.removeEventListener("message", receiveMessage, false);
  }, []);

  const ga = window[window["GoogleAnalyticsObject"]];
  const gaMark = ga?.getAll()[0]?.get("linkerParam");

  const params = new URLSearchParams({
    next: next || window.location.href,
    iframe: 1,
    ...(fastreg && { fastreg: 1 }),
    ...(ignoreIframe && { ignoreIframe: 1 }),
    ...(gaMark && { gaMark }),
    ...(showIntegrators && { [showIntegratorsKey]: true }),
    ...additionalQueryParams,
  });

  const iframeSrc = `https://id.${baseUrl}/login/?${params.toString()}`;

  return (
    <iframe
      title="Login popup"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 99999,
      }}
      height="100%"
      frameBorder="0"
      scrolling="no"
      width="100%"
      src={iframeSrc}
    />
  );
};

LoginPopup.propTypes = {
  baseUrl: PropTypes.string,
  onUserLogin: PropTypes.func,
  onUserRegister: PropTypes.func,
  onLoginClose: PropTypes.func,
  onRestorePasswordRedirect: PropTypes.func,
  fastreg: PropTypes.bool,
  next: PropTypes.string,
  ignoreIframe: PropTypes.bool,
  additionalQueryParams: PropTypes.object,
};

export default LoginPopup;
